import React, { PropsWithChildren } from 'react';
import styled from '@emotion/styled';
import MuiCard from '@mui/material/Card';
import MuiCardMedia from '@mui/material/CardMedia';

import { Link as GatsbyLink } from 'gatsby';
import { baseCardHoverZIndex, baseCardZIndex } from '~/styles';

import type { Dimension } from './BaseCard';

import { CardContentDescriptions, CardContentTitle } from '../elements';

export const Link = styled(GatsbyLink)`
  :hover {
    text-decoration: none;
  }
` as React.FC<PropsWithChildren<React.ComponentProps<typeof GatsbyLink>>>;

interface BaseCardProps {
  noShadow?: boolean;
  hoverable: number | undefined;
  dimension: Dimension;
  hoveredDimension: Dimension;
  style: React.CSSProperties;
}

export const Card: React.FC<PropsWithChildren<BaseCardProps>> = styled(MuiCard, {
  shouldForwardProp: prop =>
    !['noShadow', 'hoverable', 'dimension', 'hoveredDimension'].includes(prop),
})<BaseCardProps>`
  position: relative;
  height: ${props => `${props.dimension.height}px`};
  width: ${props => `${props.dimension.width}px`};
  max-width: ${props => props.dimension.maxWidth};
  max-height: ${props => props.dimension.maxHeight};
  -webkit-transition: all 1s;
  transition: all 1s;
  cursor: pointer;
  margin: 0;
  overflow: hidden;
  z-index: ${baseCardZIndex};
  box-shadow: ${props =>
    props.noShadow
      ? undefined
      : `5px 5px 9px 0px #00000026;
`};
  border-radius: 10px;

  ${({ hoverable, dimension, hoveredDimension }) =>
    hoverable &&
    `
      :hover {
        height: ${hoveredDimension.height}px;
        width: ${hoveredDimension.width}px;
        margin: -${(hoveredDimension.height - dimension.height) / 2}px -${
      (hoveredDimension.width - dimension.width) / 2
    }px;
        transition: 0.5s all;
        z-index: ${baseCardHoverZIndex};
        ${CardContentDescriptions} {
          display: block;
          opacity: 1;
        }
        ${CardContentTitle} {
          max-width: 280px;
        }
      }
    `};
` as React.FC<PropsWithChildren<BaseCardProps & React.ComponentProps<typeof MuiCard>>>;

type Props = {
  imageHeight: number;
  bgImageFull: boolean;
};
export const ImageWrapper = styled.div<Props>`
  margin-bottom: 0;
  position: relative;
  ${({ bgImageFull }) =>
    bgImageFull &&
    `
      height: 100%;
    `};
`;

export const CardMedia = styled(MuiCardMedia, {
  shouldForwardProp: prop => !['bgImageFull', 'imageHeight'].includes(prop),
})<Props>`
  position: relative;
  height: ${props => `${props.imageHeight}px`};
  ${({ bgImageFull }) =>
    bgImageFull &&
    `
      width: 100%;
      height: 100%;
    `};
` as React.FC<PropsWithChildren<Props & React.ComponentProps<typeof MuiCardMedia>>>;

export const Content = styled.div`
  text-align: left;
`;

const upperText = `
  position: absolute;
  top: 12px;
  transition: inherit;
`;
export const UpperLeft = styled.div`
  ${upperText} left: 10px;
`;
export const UpperRight = styled.div`
  ${upperText} right: 10px;
`;

export const FooterWrapper = styled.div`
  position: absolute;
  width: 100%;
  bottom: 8px;
  padding: 0 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
